import { render } from "./productConfirm.vue?vue&type=template&id=7408f962"
import script from "./productConfirm.vue?vue&type=script&lang=js"
export * from "./productConfirm.vue?vue&type=script&lang=js"

import "./productConfirm.vue?vue&type=style&index=0&id=7408f962&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__